import React from 'react';
import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { IUseMenu } from './IUseMenu';
import { IMenuItem } from './IMenuItem';
import useDictionary from '@ui/hooks/useDictionary';

interface IProps extends IMenuItem, Omit<MenuItemProps, 'onClick'> {
    onItemClick: IUseMenu['onItemClick'];
    onKeyDown: IUseMenu['onBtnKeyDown'];
}

const Component: React.FC<IProps> = ({
    autoFocus,
    id,
    text,
    icon,
    onClick,
    onItemClick,
    onKeyDown,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <MuiMenuItem
            autoFocus={autoFocus}
            className="menu__item"
            id={id}
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                onItemClick(e);
            }}
            onKeyDown={onKeyDown}
        >
            {icon}
            <Typography className="menu__item-text" variant="body1">
                {getWord(text)}
            </Typography>
        </MuiMenuItem>
    );
};

export const MenuItem = React.memo(Component);
